const CrifReportType =  {
    CREDIT_CHECK_CONSUMER: 1,
    QUICK_CHECK_CONSUMER: 2,
    QUICK_CHECK_BUSINESS: 3,
    CREDIT_CHECK_BUSINESS: 4,
    PREMIUM_CHECK_CONSUMER: 5,
    PREMIUM_CHECK_BUSINESS: 6,
    1: "Vérification du crédit pour le consommateur",
    2: "Vérification rapide pour le consommateur",
    3: "Vérification rapide pour les entreprises",
    4: "Vérification du crédit pour les entreprises",
    5: "Chèque de prime pour les consommateurs",
    6: "Chèque de prime pour les entreprises",
};

export default CrifReportType;